<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'events') {
            next({ name: 'evento-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'events') {
            this.$router.push({ name: 'evento-list' });
        }
    },
};
</script>
